/**
 * admin用の認証
 */
import * as types from '../../mutation-types/admin-types'
import * as httpConst from '../../../constants/httpConst'
import Vue from 'vue'

import store from 'store'
import moment from "moment";

const isAdminLoggedIn = () => {
  return (store.get('adminLoggedIn'))
}

const getCurrentUser = () => {
  const default_current_user = {
    name: null,
  }
  let current_user = null
  if (isAdminLoggedIn()) current_user = store.get('adminCurrentUser')
  return (current_user) ? current_user : default_current_user
}

const API_PATH = `${httpConst.ADMIN_BASE}/api/oauth`

const authentication = {
  namespaced: true,
  state: {
    token: null,
    adminUser: {},
    logged_in: isAdminLoggedIn(),
    name: getCurrentUser().name,
    expiresTime: null,
  },
  getters: {
    accessToken: (state) => {
      return state.token;
    },
    adminUser: (state) => {
      return state.adminUser
    },
    userName: ( state ) => {
      return (state.adminUser) ? state.adminUser.name : null
    },
    adminExpiresTime: (state) => {
      return (state.expiresTime) ? state.expiresTime : null
    },

  },
  actions: {
    signInAdmin ({ commit }, { params }) {
      const fixedParams = {
        grant_type: 'password',
        client_id: process.env.VUE_APP_ADMIN_CLIENT_ID,
        client_secret: process.env.VUE_APP_ADMIN_CLIENT_SECRET,
        scope: process.env.VUE_APP_ADMIN_SCOPE
      }
      const parameter = { ...params, ...fixedParams }
      return new Promise((resolve) => {
        const api_path = `${API_PATH}/token`
        Vue.$http.post(api_path, parameter).then( data => {
          let content = data.content
          let params = {
            access_token: content.access_token,
            user: content.user,
            refresh_token: content.refresh_token,
            created_at: content.created_at,
            expires_in: content.expires_in
          }
          commit(types.SIGN_IN_ADMIN, { params })
          resolve(content)
        })
      })
    },
    signOutAdmin ({ commit }) {
      const api_path = `${API_PATH}/revoke`
      return new Promise((resolve) => {
        Vue.$http.post(api_path).then( data => {
          commit(types.SIGN_OUT_ADMIN)
          resolve(data)
        })
      })

    }
  },
  mutations: {
    forceSignOut (state) {
      store.remove('token')
      store.remove('adminLoggedIn')
      store.remove('adminCurrentUser')
      store.remove('adminExpiresTime')
    },
    [types.SIGN_IN_ADMIN] (state, { params }) {
      state.token = params.access_token
      state.logged_in = true
      state.adminUser = params.user
      const loggedInTime = moment.unix(params.created_at)
      const expiresTime  = loggedInTime.add(params.expires_in, 'seconds').unix() * 1000
      state.expiresTime = expiresTime
      // localStorageに保持
      store.set('adminLoggedIn', true)
      store.set('adminCurrentUser', params.user)
      store.set('adminExpiresTime', expiresTime)
    },
    [types.SIGN_OUT_ADMIN] (state) {
      state.token = null
      state.adminUser = null
      state.expiresTime = null
      // localStorageに保持
      store.remove('token')
      store.remove('adminLoggedIn')
      store.remove('adminCurrentUser')
      store.remove('adminExpiresTime')
    },
  },
}

export default authentication
